const themes = {
  normal: {
    hero: {
      backgroundColor: 'var(--color-background-hero)'
    },
    logo: {
      color: 'var(--color-logo)'
    },
    motto: {
      color: 'var(--color-white)'
    },
    button: {
      color: 'var(--color-gray)',
      borderColor: 'var(--color-gray)',
      colorHover: ' var(--color-gray-dark)',
      backgroundColorHover: 'var(--color-gray)'
    }
  },
  alternate: {
    hero: {
      backgroundColor: 'var(--color-background-hero-alternate)'
    },
    logo: {
      color: 'var(--color-logo-alternate)'
    },
    motto: {
      color: 'var(--color-white)'
    },
    button: {
      color: 'var(--color-yellow)',
      borderColor: 'var(--color-yellow)',
      colorHover: 'var(--color-purple)',
      backgroundColorHover: 'var(--color-yellow)'
    }
  }
};

export default themes;
